/**
 * getType(10)          //==>> Number
 * getType("")          //==>> String
 * getType([])          //==>> Array
 * getType({})          //==>> Object
 * getType(null)        //==>> Null
 * getType(undefined)   //==>> Undefined
 * getType(true)        //==>> Boolean
 * getType(getType)    	//==>> Function
 * getType(new Date())  //==>> Date
 */
const getTypeUtils = (obj: unknown): string =>
    (Object as any).prototype.toString.call(obj).match(/.* (.*)\]/)[1];

export const isNumber = (obj: unknown): obj is number =>
    typeof obj === 'number' && !isNaN(obj);

export const isString = (obj: unknown): obj is string =>
    typeof obj === 'string';

export const isArray = (obj: unknown): obj is Array<any> => Array.isArray(obj);

export const isObject = (obj: unknown): obj is object =>
    getTypeUtils(obj) === 'Object';

export const isNull = (obj: unknown): obj is null =>
    getTypeUtils(obj) === 'Null';

export const isUndefined = (obj: unknown): obj is undefined =>
    getTypeUtils(obj) === 'Undefined';

export const isFunction = (obj: unknown): obj is Function =>
    getTypeUtils(obj) === 'Function';

export const isDate = (obj: unknown): obj is Date =>
    getTypeUtils(obj) === 'Date';

export const isBoolean = (obj: unknown): obj is boolean =>
    getTypeUtils(obj) === 'Boolean';

export const isNullOrUndefined = (obj: unknown): obj is null | undefined =>
    isNull(obj) || isUndefined(obj);
